import { registry } from './icons';

const PATH_PATTERN = / d="([^"]+)"/;
const paths = Object.fromEntries(Object.entries(registry).map(([name, svg]) => [name, svg.match(PATH_PATTERN)?.[1] || '']));

// Material Symbols are drawn on a 960-unit grid whose origin is at the bottom-left, hence the negative y origin.
export default function Icon({ name, className = '', title }) {
  const path = paths[name];
  if (!path) return null;
  return (
    <svg className={`icon ${className}`.trim()} viewBox="0 -960 960 960" fill="currentColor" focusable="false" role={title ? 'img' : undefined} aria-label={title} aria-hidden={title ? undefined : 'true'}>
      <path d={path} />
    </svg>
  );
}

export { paths as iconPaths };
